<nav class="align-items-end desktop">
  <ul class="ps-0">
    @for (route of getRoutes(); track $index) {
    <ng-container>
      @if (isMenuItemDisplayed(route) | async) {
      <ng-container>
        <!-- No child -->
        @if (!route.children || (route.children && route.children.length === 0)) {
        <ng-container>
          <li class="me-3" [routerLink]="route.path" routerLinkActive="active">
            {{route.data?.title | translate}}
          </li>
        </ng-container>
        }
        <!-- Has children -->
        @if (route.children && route.children.length > 0) {
        <ng-container>
          <li class="me-3" [matMenuTriggerFor]="menu" [routerLink]="route.path" routerLinkActive="active">
            {{route.data?.title | translate}}
          </li>
          <mat-menu class="py-3 px-2" #menu="matMenu" [overlapTrigger]="false">
            @for (child of route.children; track $index) {
            <ng-container>
              @if(child.data?.title){
              <button mat-menu-item [routerLink]="route.path + '/' + child.path">
              </button>
              }
            </ng-container>
            }
          </mat-menu>
        </ng-container>
        }
      </ng-container>
      }
    </ng-container>
    }
  </ul>
</nav>
<nav class="mobile">

  @for (route of getRoutes(); track $index) {
  <ul>
    @if (route.data?.title) {
    <ng-container>
      @if (route.path) {
      <li (click)="close()" role="navigation" (keyup)="close()" class="pointer" routerLinkActive="active" [routerLink]="route.path">
        {{route.data?.title | translate}}
      </li>
      }
      <!-- Has children -->
      @if(route.children && route.children.length > 0){
      <ng-container>
        @for (child of route.children; track $index) {
        <li (click)="close()" role="navigation" (keyup)="close()" class="pointer" routerLinkActive="active" [routerLink]="route.path + '/' + child.path">
          {{child.data?.title | translate}}
        </li>
        }
      </ng-container>
      }
    </ng-container>
    }
  </ul>
  }
</nav>